export const UI_LOGIN_ALERT_ID = "UI_LOGIN_ALERT_ID";
export const LOGIN_LIMIT_ALERT_ID = "LOGIN_LIMIT_ALERT_ID";

export const enum PLATFORM {
	Website = "Website",
	Android = "Android",
	Ios = "Ios",
}
